// generated by the plop

import { PaginateQuery, PaginatorModel, UnknownError } from 'symbols';
import { InvoiceFilterModel, InvoiceModel } from '../../symbols';

export class GetInvoiceList {
  static type = '[invoiceList] GetInvoiceList';

  constructor(public lazy: boolean, public filter?: PaginateQuery<InvoiceFilterModel>) {
  }
}

export class GetInvoiceListSuccess {
  static type = '[invoiceList] GetInvoiceListSuccess';

  constructor(public invoiceList: PaginatorModel<InvoiceModel>, public lazy: boolean) {
  }
}

export class GetInvoiceListError {
  static type = '[invoiceList] GetInvoiceListError';

  constructor(public error: UnknownError) {
  }
}

export class ClearScrollPositionInvoiceList {
  static type = '[invoiceList] ClearScrollPositionInvoiceList';
}

export class UpdateScrollPositionInvoiceList {
  static type = '[invoiceList] UpdateScrollPositionInvoiceList';

  constructor(public position: number) {
  }
}

export class SetLastOpenedInvoiceId {
  static type = '[invoiceList] SetLastOpenedInvoiceId';

  constructor(public invoiceId: string) {
  }
}

export class UpdatedInvoiceByWS {
  static type = '[invoiceList] UpdatedInvoiceByWS';

  constructor(public invoice: InvoiceModel) {
  }
}

export class CreatedInvoiceByWS {
  static type = '[invoiceList] CreatedInvoiceByWS';

  constructor(public invoice: InvoiceModel) {
  }
}
